import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from '../dashboard/dashboard/dashboard.component';
import { RiderRidesComponent } from './rider-rides/rider-rides.component';
import { RiderRidesRequestsComponent } from './rider-rides-requests/rider-rides-requests.component';
import { CoriderRidesRequestsComponent } from './corider-rides-requests/corider-rides-requests.component';
import { ProfileComponent } from './profile/profile.component';
import { SharedModule } from '../shared/shared.module';
import { DiscussionComponent } from './discussion/discussion.component';
import { DiscussionInputComponent } from './discussion-input/discussion-input.component';
import { MessageService } from './message.service';
import { MatSidenavModule, MatListModule } from '@angular/material';
import { OverviewComponent } from './overview/overview.component';

@NgModule({
  declarations: [
    DashboardComponent,
    RiderRidesComponent,
    RiderRidesRequestsComponent,
    CoriderRidesRequestsComponent,
    ProfileComponent,
    DiscussionComponent,
    DiscussionInputComponent,
    OverviewComponent,
  ],
  imports: [
    CommonModule,
    DashboardRoutingModule,
    SharedModule,
    MatSidenavModule,
    MatListModule
  ],
  providers: [MessageService]
})
export class DashboardModule {}
